export default __webpack_public_path__ + "static/team-hero-390519b6e6df54619bad704c06071492.png";